import React from 'react';
import styled from 'styled-components';
import background from '../../assets/images/back.png';

export interface IEquipmentSlide {
  img: string;
  title: string;
  subtitle: string;
  weight?: string;
  energy?: string;
  gabarites: string;
  corpus: string;
  additional: string;
  subAdditional?: string;
  specifications: string[];
  icon?: string;
  classN: string;
}

const EquipmentSlide = ({
  weight,
  subAdditional,
  title,
  subtitle,
  specifications,
  img,
  gabarites,
  corpus,
  additional,
  icon,
  classN
}: IEquipmentSlide) => {
  return (
    <StyledEquipmentSlide>
      <EquipImageBlock>
        <EquipImage src={img} alt="equip" className={classN} />
      </EquipImageBlock>
      <StyledEquipmentBlock>
        <FlexBlock>
          <StyledEquipmentBlockTitle>{title}</StyledEquipmentBlockTitle>
          <StyledEquipmentBlockSubTitle>
            {subtitle}
          </StyledEquipmentBlockSubTitle>
        </FlexBlock>
        <InfoBlock>
          {weight ? (
            <StyledEquipmentBlockSpan>
              Вес:
              <StyledEquipmentBlockSubSpan>
                {weight}
              </StyledEquipmentBlockSubSpan>
            </StyledEquipmentBlockSpan>
          ) : null}
          <StyledEquipmentBlockSpan>
            Габариты:
            <StyledEquipmentBlockSubSpan>
              {gabarites}
            </StyledEquipmentBlockSubSpan>
          </StyledEquipmentBlockSpan>
          <StyledEquipmentBlockSpan>
            Корпус:
            <StyledEquipmentBlockSubSpan>{corpus}</StyledEquipmentBlockSubSpan>
          </StyledEquipmentBlockSpan>
          <StyledEquipmentBlockSpan>{additional}</StyledEquipmentBlockSpan>
          {subAdditional ? (
            <StyledEquipmentBlockAdditional>
              {subAdditional}
            </StyledEquipmentBlockAdditional>
          ) : null}
          <ul>
            {specifications.map((item, index) => (
              <li
                style={{ listStyle: 'inside', marginBottom: '12px' }}
                key={index}
              >
                <StyledEquipmentBlockAdditional>
                  {item}
                </StyledEquipmentBlockAdditional>
              </li>
            ))}
          </ul>
        </InfoBlock>
        {icon ? (
          <StyledEquipmentBlockIcon src={icon} alt="additional-icon" />
        ) : null}
      </StyledEquipmentBlock>
    </StyledEquipmentSlide>
  );
};

const StyledEquipmentSlide = styled.div`
  display: flex;
`;

const StyledEquipmentBlock = styled.div`
  display: flex;
  flex-direction: column;
  width: 41.2%;
  position: relative;
  padding: 21px 0px 0px 2.4%;
  @media (max-width: 1440px) {
    width: 51.4%;
  }
  @media (max-width: 1135px) {
    padding: 10px 0px 0px 4.4%;
  }
  @media (max-width: 890px) {
    // padding: 10px 0px 0px 0px;
  }
  @media (max-width: 599px) {
    padding: 85px 0px 0px 4.4%;
    width: 100%;
  }
`;

const StyledEquipmentBlockTitle = styled.h2`
  font-weight: 700;
  font-size: 32px;
  @media (max-width: 599px) {
    font-size: 24px;
  }
`;
const StyledEquipmentBlockSubTitle = styled.h2`
  font-weight: 400;
  font-size: 24px;
  margin-left: 17px;
  color: #a2a8b0;
`;
const StyledEquipmentBlockSpan = styled.span`
  font-weight: 600;
  font-size: 20px;
  margin-top: 17px;
`;

const StyledEquipmentBlockAdditional = styled.span`
  font-weight: 400;
  font-size: 20px;
  margin-top: 14px;
`;

const StyledEquipmentBlockSubSpan = styled.span`
  font-weight: 400;
  font-size: 20px;
  margin-left: 9px;
`;

const StyledEquipmentBlockIcon = styled.img`
  position: absolute;
  bottom: 45px;
  right: 0;
  z-index: -1;
  @media (max-width: 1135px) {
    display: none;
  }
`;

const InfoBlock = styled.div`
  margin-top: 10px;
  display: flex;
  flex-direction: column;
`;

const FlexBlock = styled.div`
  display: flex;
  align-items: center;
`;

const EquipImageBlock = styled.div`
  width: 42%;
  height: 448px;
  background-image: url(${background});
  background-repeat: no-repeat;
  background-size: cover;
  background-position: right;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  @media (max-width: 1135px) {
    width: 48%;
    height: 348px;
  }
  @media (max-width: 599px) {
    display: none;
  }
`;

const EquipImage = styled.img`
  &.cube {
    margin-right: 100px;
  }
  &.big {
    margin-right: 100px;
    margin-bottom: 50px;
  }
  @media (max-width: 1250px) {
    &.power {
      width: 100%;
    }
  }
  @media (max-width: 1200px) {
    &.cube {
      margin-right: 75px;
    }
  }
  @media (max-width: 1135px) {
    &.cube {
      margin-right: 50px;
      width: 300px;
    }
    &.big {
      width: 238px;
      margin-right: 50px;
    }
  }
  @media (max-width: 850px) {
    &.cube {
      margin-right: 10px;
      width: 275px;
    }
  }
`;

export default EquipmentSlide;
